import React, { FunctionComponent } from 'react';
import { Box, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import AirlineSeatReclineExtraIcon from '@material-ui/icons/AirlineSeatReclineExtra';
import threeSixtyViewToggleStyles from './threeSixtyViewToggleStyles';
import { ImageType } from '../../../../../gqlCommon/enum/ImageType';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export interface ThreeSixtyViewToggleProps {
  displayType: ImageType;
  setDisplayType: (displayType: ImageType) => void;
}

const ThreeSixtyViewToggle: FunctionComponent<ThreeSixtyViewToggleProps> = ({ displayType, setDisplayType }) => {
  const {
    spc: {
      customise: { showInteriorViewCTA, showExteriorViewCTA },
    },
  } = useTheme<ISpcTheme>();
  const styles = threeSixtyViewToggleStyles();

  return (
    <Box className={styles.toggleContainer}>
      {!!showExteriorViewCTA && (
        <DriveEtaIcon
          data-test="three_sixty:exterior_360"
          className={clsx(styles.icon, { [styles.activeIcon]: displayType === ImageType.EXTERIOR_360 })}
          onClick={() => setDisplayType(ImageType.EXTERIOR_360)}
        />
      )}
      {!!showInteriorViewCTA && (
        <AirlineSeatReclineExtraIcon
          data-test="three_sixty:panoramic_view"
          className={clsx(styles.icon, { [styles.activeIcon]: displayType === ImageType.INTERIOR_360_PANORAMIC })}
          onClick={() => setDisplayType(ImageType.INTERIOR_360_PANORAMIC)}
        />
      )}
    </Box>
  );
};

export default ThreeSixtyViewToggle;
